module.exports = __webpack_public_path__ + "static/media/login-8_06Dec2019_Tejas_1576847098676.11d48edc.fw";